export const createCustomTemplatePageMessages = {
  // Page header
  pageTitle: 'Tell your own personal story!',

  // Navigation
  backToTemplates: 'Back to Templates',
  successNavigateMessage: 'Template created! Starting story creation...',

  // Success states
  templateCreated: 'Story template created successfully!',
  redirecting: 'Starting story creation...',

  // Error states
  createError: 'Failed to create story template',
  unexpectedError: 'An unexpected error occurred. Please try again.',

  // Loading states
  loading: 'Loading...',
  creating: 'Creating template...',

  // Accessibility
  pageAriaLabel: 'Create custom story template page',
  formContainerAriaLabel: 'Custom story template creation form container',
} as const;
